import { AuthGuard } from "@admin/components/molecules/AuthGuard";
import { LicenseGuard } from "@admin/components/molecules/LicenseGuard";
import { Header } from "@admin/components/organisms/Header";
import { Sidebar } from "@admin/components/organisms/Sidebar";
import * as Tooltip from "@radix-ui/react-tooltip";
import { Outlet } from "react-router";

export default function PanelLayout() {
  return (
    <div className="flex grow">
      <AuthGuard>
        <Tooltip.Provider>
          <Sidebar />
          <div className="flex grow flex-col">
            <main className="scrollable-y-auto [scrollbar-width:auto] [--tw-scrollbar-thumb-color:var(--tw-content-scrollbar-color)] flex flex-col grow items-stretch rounded-xl bg-[#F6F6F9] dark:bg-[--tw-content-bg-dark] border border-gray-300 dark:border-gray-200 lg:ms-[--tw-sidebar-width] pt-14 md:pt-5 mt-0 lg:mt-[15px] md:m-[15px] p-5">
              <Header />
              <LicenseGuard>
                <Outlet />
              </LicenseGuard>
            </main>
          </div>
        </Tooltip.Provider>
      </AuthGuard>
    </div>
  );
}
